import {
    REFERRAL_LIST_BANNER,
    REFERRAL_LIST_PRESENTER,
    GET_PERCENT_PRESENTER
} from "../../store/actions.type";
import {
    COMMON_SET_PERCENT_PRESENTER,
    COMMON_SET_SNACK
} from "../../store/mutations.type";
import {ReferralService} from "~/common/service.api";

const state = {
    accounts : {},
    percentPresenter : 0
};

// getters
const getters = {
    percentPresenter: state => state.percentPresenter
};

// actions
const actions = {
    [REFERRAL_LIST_BANNER]({commit}) {
        return new Promise((resolve) => {
            ReferralService.get_list_banner()
            .then(res => {
                if(res.data.success) {
                    resolve(res.data);
                }else{
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
            });
        });
    },
    [REFERRAL_LIST_PRESENTER]({commit}) {

        return new Promise((resolve) => {
            ReferralService.get_list_presenter()
            .then(res => {
                if(res.data.success) {
                    resolve(res.data);
                }else{
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
            });
        });
    },
    [GET_PERCENT_PRESENTER]({commit}) {
        return ReferralService.get_percent_presenter()
            .then(({data}) => {
                if(data.success){
                    commit(COMMON_SET_PERCENT_PRESENTER, data.data.percent);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
            });
    },
};

// mutations
const mutations = {
    [COMMON_SET_PERCENT_PRESENTER](state, percentPresenter){
        state.percentPresenter = percentPresenter;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
